import React from "react";
import { useMediaQuery } from "@mui/material";

const CustomO: React.FC = () => {
	const mdScreen = useMediaQuery("(min-width:767px)");

	return (
		<div className="inline">
			<span className="relative inline-block">
				<span className="relative z-10 text-[#E09146]">o</span>
				<span
					className="absolute inset-0 bg-[#E09146] rounded-full"
					style={{
						left: "0.02em",
						height: "0.8em",
						top: mdScreen ? "0.15em" : "11%",
					}}
				></span>
			</span>
		</div>
	);
};

interface CustomTextWithOProps {
	text: string;
	position: number;
}

const CustomTextWithO: React.FC<CustomTextWithOProps> = ({
	text,
	position,
}) => {
	const beforeO = text.slice(0, position);
	const afterO = text.slice(position + 1);

	return (
		<div className="inline whitespace-nowrap">
			{beforeO}
			<CustomO />
			{afterO}
		</div>
	);
};

export default CustomO;
export { CustomTextWithO };
